export { RecentlyViewedCloudSitesQueryWrapper } from './src/recently-viewed-cloud-sites-query-wrapper';
export { getRecentlyViewedCloudSiteWidgetContent } from './src/recently-viewed-cloud-sites-widget-content';
